import type { EventDict } from '@sdk/schedule/helpers/getEventsDict';
import type { User } from '@sdk/users/types/User';
import type { DisplayLayoutModeType } from '@sdk/schedule/types/DisplayLayoutModeType';

import type { FormattedDateString } from '../types/FormattedDateString';
import type { EventCollectionType } from '../types';
import useAllEvents from '../windowed/hooks/useAllEvents';

export type ScheduleContextType = {
  allEventsDict: EventDict | null;
  allUsers: {
    [key in string]: User;
  };
  personasDict:
    | {
        [key in string]: any;
      }
    | null;
  displayMode: DisplayLayoutModeType;
  currentPeriodDays: FormattedDateString[];
};

type Props = {
  eventCollection: EventCollectionType;
  personaCollection: {
    personasDict: {
      [key in string]: any;
    };
  };
  displayMode: DisplayLayoutModeType;
  currentPeriodDays: FormattedDateString[];
};

const useScheduleCtxBuilder = ({
  eventCollection,
  personaCollection,
  displayMode,
  currentPeriodDays,
}: Props): ScheduleContextType => {
  const allEventsDict = useAllEvents(eventCollection.allEvents);
  const { allUsers } = eventCollection;
  const { personasDict } = personaCollection;

  return { allEventsDict, allUsers, personasDict, displayMode, currentPeriodDays };
};

export default useScheduleCtxBuilder;
